import React, { useEffect } from "react";
import "./Company.css";
import Nagoya from "./Nagoya";
import Fukuoka from "./Fukuoka";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { ListViewComponent } from "@syncfusion/ej2-react-lists";
import { Inject } from "@syncfusion/ej2-react-grids";
import {
  MapsComponent,
  LayersDirective,
  LayerDirective,
  MapsTooltip,
  MarkersDirective,
  MarkerDirective,
  Marker,
  Legend,
  Zoom,
} from "@syncfusion/ej2-react-maps";
import { japanMap } from "./japanMap";

const Company: React.FC = () => {
  useDocumentTitle("会社案内");

  const historyData = [
    { text: "平成26年5月1日 - 会社設立" },
    { text: "令和1年8月8日 - 会社移転" },
    { text: "令和3年9月27日 - 会社移転" },
    { text: "令和4年11月1日 - 博多サテライトオフィス設立" },
    { text: "令和5年10月11日 - AWS セレクトティアサービスパートナー 認定" },
    { text: "令和7年12月12日 - ISO/IEC 27001（ISMS）認証取得" },
  ];

  const companyData = [
    { val1: "社名", val2: "株式会社IT plus" },
    { val1: "設立", val2: "平成26年5月1日" },
    {
      val1: "所在地",
      val2: "〒460-0002　名古屋市中区丸の内一丁目17番19号\nキリックス丸の内ビル705号\nTEL（052）684-5742　FAX（052）684-5743",
    },
    { val1: "資本金", val2: "5,000,000円" },
    { val1: "社員数", val2: "30人" },
    { val1: "代表取締役", val2: "岡田　達也" },
    { val1: "取引銀行", val2: "名古屋銀行、瀬戸信用金庫" },
    {
      val1: "福利厚生",
      val2: "各種保険：健康保険、厚生年金保険、雇用保険\n各種手当：超過手当、通勤手当\n健康診断：年一回実施 \n福利厚生俱楽部",
    },
    {
      val1: "認定等",
      val2: "ISO/IEC 27001（ISMS）認証、AWSセレクトティアサービスパートナー認定",
      isCertification: true,
    },
  ];

  useEffect(() => {
    const animatedElements = document.querySelectorAll(".hidden");

    const animateOnScroll = () => {
      animatedElements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        if (
          rect.top <=
          (window.innerHeight || document.documentElement.clientHeight)
        ) {
          element.classList.add("fade-in-up");
        }
      });
    };
    animateOnScroll();
    window.addEventListener("scroll", animateOnScroll);
    return () => window.removeEventListener("scroll", animateOnScroll);
  }, []);

  const template = (item: { val1: string; val2: string; isCertification?: boolean }) => {
    return (
      <div className="key-value">
        <span className="key">{item.val1}:</span>&nbsp;
        <span className="value">
          {item.val2.split("\n").map((line: string, lineIndex: number) => (
            <div key={lineIndex}>{line}</div>
          ))}
          {item.isCertification && (
            <div className="certification-logos">
              <img src="/images/isms-logo.jpg" alt="ISO/IEC 27001" className="certification-logo" />
              <img src="/images/infoaws_img1.png" alt="AWS Partner" className="certification-logo aws-logo" />
            </div>
          )}
        </span>
      </div>
    );
  };

  return (
    <div className="company-page">
      <section className="company-info hidden">
        <h2>会社案内</h2>

        <div className="company-history hidden">
          <h3>沿革</h3>
          <ListViewComponent
            dataSource={historyData}
            fields={{ text: "text" }}
            cssClass="history-list"
          />
        </div>

        <div className="company-overview hidden">
          <h3>会社概要</h3>
          <ListViewComponent
            dataSource={companyData as any}
            template={template}
            cssClass="overview-list"
          />
        </div>
      </section>

      <div className="access-container hidden">
        <h2>アクセス</h2>
        {/* マップ */}
        <div className="map-container hidden">
          <p>拠点一覧</p>
          <MapsComponent
            centerPosition={{ latitude: 36.2048, longitude: 138.2529 }}
            legendSettings={{ visible: true }}
            zoomSettings={{
              enable: false,
              toolbarSettings: { horizontalAlignment: "Near" },
              shouldZoomInitially: false,
            }}
          >
            <Inject services={[Marker, Legend, MapsTooltip, Zoom]} />
            <LayersDirective>
              <LayerDirective
                shapeData={japanMap}
                shapeSettings={{
                  fill: "#67C6E3",
                  border: { color: "#B1AFFF", width: 1 },
                  opacity: 1.0,
                }}
              >
                <MarkersDirective>
                  <MarkerDirective
                    visible={true}
                    shape="Circle"
                    height={15}
                    width={15}
                    fill="#4CCD99"
                    dataSource={[
                      {
                        latitude: 35.1702,
                        longitude: 136.8833,
                        name: "Nagoya",
                      },
                    ]}
                  />
                  <MarkerDirective
                    visible={true}
                    shape="Circle"
                    height={15}
                    width={15}
                    fill="#5356FF"
                    dataSource={[
                      { latitude: 33.5902, longitude: 130.42, info: "Fukuoka" },
                    ]}
                  />
                  <MarkerDirective
                    visible={true}
                    height={0}
                    width={0}
                    animationDelay={0}
                    template='<div id="marker2">名古屋</div>'
                    tooltipSettings={{
                      visible: true,
                      valuePath: "info",
                    }}
                    dataSource={[
                      {
                        latitude: 35.1702,
                        longitude: 136.8833,
                        info: "名古屋本社(Nagoya Headquarters)",
                      },
                    ]}
                  />
                  <MarkerDirective
                    visible={true}
                    height={20}
                    width={20}
                    animationDuration={0}
                    template='<div id="marker2">博多</div>'
                    tooltipSettings={{
                      visible: true,
                      valuePath: "info",
                    }}
                    dataSource={[
                      {
                        latitude: 33.5902,
                        longitude: 130.42,
                        info: "博多サテライトオフィス(Hakata Satellite Office)",
                      },
                    ]}
                  />
                </MarkersDirective>
              </LayerDirective>
            </LayersDirective>
          </MapsComponent>
        </div>

        {/* ダッシュボード */}
        <div className="dashboard-container">
          <Nagoya />
          <Fukuoka />
        </div>
      </div>
    </div>
  );
};

export default Company;
